import { COURSE_MESSAGES } from "../messages";
import type { FaqItem } from "../types";

interface CourseFaqProps {
    items?: FaqItem[];
}

// Expandable questions (native <details>: keyboard accessible, no JS needed)
const CourseFaq = ({ items }: CourseFaqProps) => {
    return (
        <section className="flex flex-col w-full mt-14">
            <h2 className="text-2xl font-bold mb-5">{COURSE_MESSAGES.faq}</h2>

            {Array.isArray(items) && items.length > 0 ? (
                <div className="flex flex-col gap-3">
                    {items.map((item, index) => (
                        <details key={index} className="border border-gray-200 rounded-lg p-5 bg-white">
                            <summary className="font-bold text-lg cursor-pointer">
                                {item.question || item.title}
                            </summary>
                            <p className="mt-4 text-gray-700 leading-8 whitespace-pre-line">
                                {item.answer || item.description}
                            </p>
                        </details>
                    ))}
                </div>
            ) : (
                <p className="text-gray-500">{COURSE_MESSAGES.noFaq}</p>
            )}
        </section>
    );
};

export default CourseFaq;